import { render, staticRenderFns } from "./ColorSpecEditor.vue?vue&type=template&id=dc005eb2&scoped=true"
import script from "./ColorSpecEditor.vue?vue&type=script&lang=js"
export * from "./ColorSpecEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc005eb2",
  null
  
)

export default component.exports